import React from 'react';
import classNames from 'classnames';
import { Url } from '.';

export enum StepType {
	previous = 'previous',
	current = 'current',
	next = 'next',
}

interface TrackerStep {
	url?: Url;
	type: StepType;
}
const Step: React.FC<TrackerStep> = ({ url, type }) => {
	return (
		<>
			<div className="absolute inset-0 flex items-center" aria-hidden="true">
				<div
					className={classNames(
						type === StepType.next ? 'ml-6' : 'ml-10',
						'h-0.5 mr-4 w-full bg-current'
					)}
				/>
			</div>
			<div
				className={classNames(
					type === StepType.next
						? 'w-1.5 h-1.5 md:w-2 md:h-2 bg-current'
						: 'w-5 h-5 md:w-7 md:h-7 border-[6px] md:border-8 border-current',
					'relative flex items-center justify-center rounded-full'
				)}
				aria-current={type === StepType.current && 'step'}>
				{url?.label && <span className="sr-only">{url.label}</span>}
			</div>
		</>
	);
};

export default Step;
